export const functions = {
  methods: {
    _(val) {
      let _t = this;

      let page = 'App';

      if (_t.pageData && _t.pageData.page) {
        page = _t.pageData.page;
      }

      if (_t.pageData && _t.pageData.subPage) {
        page += _t.pageData.subPage;
      }

      if (_t.$store.state.pages[page] && _t.$store.state.pages[page][val]) {
        return _t.$store.state.pages[page][val];
      }

      return '';
    },
    bgImgStyle: function(images, index, array) {
      let stages = [];

      for (let i in images) {
        stages.push('url(' + images[i] + ') ' + i);
      }

      let str = 'image-set(' + stages.join(',') + ')';

      let style = {
        'background-image': ['-webkit-' + str, str]
      };

      if (index !== undefined && array) {
        style['z-index'] = array.length - index;
      }

      return style;
    }
  }
};
